import React, {useState} from "react";
import PropTypes from "prop-types";
import {useAuth0} from "@auth0/auth0-react";

const toggleStyle = {
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "8px 14px",
    maxWidth: "250px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "#fff",
    color: "#111827"
};

const nameStyle = {
    fontWeight: "600",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "120px"
};

const avatarStyle = {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    objectFit: "cover",
    flexShrink: 0
};

const dropdownStyle = {
    position: "absolute",
    top: "110%",
    right: 0,
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "10px",
    minWidth: "160px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    zIndex: 1000,
    overflow: "hidden"
};

const logoutButtonStyle = {
    width: "100%",
    padding: "12px 15px",
    border: "none",
    background: "white",
    color: "#111827",
    margin: 0,
    borderRadius: 0,
    textAlign: "left",
    cursor: "pointer"
};

const UserMenu = ({userName, userImage}) => {
    const {logout} = useAuth0();
    const [openDropdown, setOpenDropdown] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const handleLogoutAccount = async () => {
        setIsLoggingOut(true);

        try {
            await logout({
                logoutParams: {
                    returnTo: `${window.location.origin}/admin/update/profile`,
                },
            });
        } catch (err) {
            console.error(err);
            setIsLoggingOut(false);
        }
    };

    return (
        <div style={{position: "relative"}}>
            <button type="button"
                    onClick={() => setOpenDropdown(prev => !prev)}
                    className="btn btn-light"
                    style={toggleStyle}>
                <span style={nameStyle}>{userName}</span>
                <img src={userImage} alt="user" style={avatarStyle}/>
                <span style={{
                    fontSize: "12px",
                    transform: openDropdown ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.2s"
                }}>▼</span>
            </button>

            {openDropdown && (
                <div style={dropdownStyle}>
                    <button type="button"
                            onClick={handleLogoutAccount}
                            disabled={isLoggingOut}
                            style={logoutButtonStyle}>
                        Logout
                        {isLoggingOut && <i className="fa fa-spinner fa-spin ms-2"/>}
                    </button>
                </div>
            )}
        </div>
    );
};

UserMenu.propTypes = {
    userName: PropTypes.string.isRequired,
    userImage: PropTypes.string
};

export default UserMenu;
